import { TenantPage } from 'layouts';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { useTranslation } from 'react-i18next';
import { stockQuantityService } from '../api/stock-quantity.service';
import { StockQuantitiesColumns } from '../stock-quantities';
import { useMemo } from 'react';

function AllQuantities() {
  const { t } = useTranslation();
  const translationPrefix = 'pages.stock_quantity.all';
  const columns = StockQuantitiesColumns();

  const totalsOuterParams = useMemo(() => {
    return {
      exclude_stock: true
    };
  }, []);

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <EnhancedDataGrid
        service={stockQuantityService}
        getMethod={stockQuantityService.getStockQuantityWithLocation}
        outerParams={totalsOuterParams}
        columns={columns}
      />
    </TenantPage>
  );
}

export default AllQuantities;
